import { Controller } from '@hotwired/stimulus'
export default class extends Controller {
  connect() {
    this.setup()
    this.parentObserver = new MutationObserver(() => {
      if (!this.gutter?.isConnected) this.setup()
    })
    this.parentObserver.observe(this.element.parentNode, { childList: true })
  }

  disconnect() {
    this.parentObserver?.disconnect()
    this.resizeObserver?.disconnect()
    this.gutter?.remove()
    this.parent?.classList.remove('line-numbered-textarea-parent')
    this.element.classList.remove('line-numbered-input')
  }

  setup() {
    this.parent = this.element.parentNode
    if (getComputedStyle(this.parent).position === 'static') {
      this.parent.classList.add('line-numbered-textarea-parent')
    }
    this.gutter = document.createElement('div')
    this.gutter.className = 'line-numbers-gutter'
    this.gutter.setAttribute('aria-hidden', 'true')
    this.parent.insertBefore(this.gutter, this.element)
    this.element.classList.add('line-numbered-input')
    this.render()
    this.position()
    requestAnimationFrame(() => this.position())
    this.resizeObserver?.disconnect()
    this.resizeObserver = new ResizeObserver(() => this.position())
    this.resizeObserver.observe(this.element)
  }

  render() {
    if (!this.gutter?.isConnected) this.setup()
    const lines = this.element.value.split('\n').length || 1
    let out = ''
    for (let i = 1; i <= lines; i++) out += i + '\n'
    this.gutter.textContent = out
  }

  sync() {
    this.gutter.scrollTop = this.element.scrollTop
  }

  position() {
    const rect = this.element.getBoundingClientRect()
    Object.assign(this.gutter.style, {
      position: 'absolute',
      top: `${this.element.offsetTop}px`,
      left: `${this.element.offsetLeft}px`,
      height: `${rect.height}px`
    })
  }
}
